import { render } from "./ProductCategoryProductsComponent.vue?vue&type=template&id=6b748787"
import script from "./ProductCategoryProductsComponent.vue?vue&type=script&lang=js"
export * from "./ProductCategoryProductsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"platform/themes/staderecord/assets/js/components/ProductCategoryProductsComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b748787"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b748787', __exports__)) {
    api.reload('6b748787', __exports__)
  }
  
  module.hot.accept("./ProductCategoryProductsComponent.vue?vue&type=template&id=6b748787", () => {
    api.rerender('6b748787', render)
  })

}


export default __exports__